export default __webpack_public_path__ + "static/logo-1b43d3ebdbd3577a80a3c26956736432.svg";